/**
 * Looks up a bonus / template / freespin by URL id against the combined feed payload
 * Returns null when bonusId is absent or nothing matches
 */
export const BONUS_KIND = {
  BONUS: 'bonus',
  FREESPIN: 'freespin',
  SPORT: 'sport',
  TEMPLATE: 'template',
};

export const resolveBonusEntity = (
  bonusId,
  { availableTemplates = [], clientBonuses = [], freespins = [] } = {},
) => {
  if (bonusId == null || bonusId === '') {
    return null;
  }

  const matchedClientBonus = clientBonuses.find(b => String(b.id) === String(bonusId));
  if (matchedClientBonus) {
    return { entity: matchedClientBonus, kind: BONUS_KIND.BONUS };
  }

  const matchedTemplate = availableTemplates.find(t => String(t.id) === String(bonusId));
  if (matchedTemplate) {
    return { entity: matchedTemplate, kind: BONUS_KIND.TEMPLATE };
  }

  const matchedFreespin = freespins.find(fs => String(fs.id) === String(bonusId));
  if (matchedFreespin) {
    return { entity: matchedFreespin, kind: BONUS_KIND.FREESPIN };
  }

  return null;
};

export const findActivatedInstanceId = (bonusId, clientBonuses = []) => {
  if (bonusId == null || bonusId === '') {
    return null;
  }

  const activatedInstance = clientBonuses
    .filter(bonus => String(bonus.bonusTemplateId) === String(bonusId))
    .reduce(
      (newest, bonus) =>
        !newest || (bonus.createTime ?? 0) > (newest.createTime ?? 0) ? bonus : newest,
      null,
    );

  return activatedInstance ? activatedInstance.id : null;
};
